export default __webpack_public_path__ + "images/arrow_left-8212e9a2833778080e3bed650bd7fdb5.svg";